"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeTag = exports.DailyResults = exports.TermsState = exports.Session = exports.MonthlyStatement = exports.APIAuthToken = exports.APIAuthAccess = exports.APIClient = void 0;
const class_transformer_1 = require("class-transformer");
const typeorm_1 = require("typeorm");
const model_1 = require("./model");
const utils_1 = require("./utils");
const version_1 = require("./version");
let APIClient = class APIClient {
    constructor(vals = {}) {
        Object.assign(this, vals);
    }
};
exports.APIClient = APIClient;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], APIClient.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIClient.prototype, "secret", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIClient.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIClient.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIClient.prototype, "website", void 0);
exports.APIClient = APIClient = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], APIClient);
let APIAuthAccess = class APIAuthAccess {
    constructor(vals = {}) {
        this.scopes = [];
        Object.assign(this, vals);
    }
};
exports.APIAuthAccess = APIAuthAccess;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], APIAuthAccess.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], APIAuthAccess.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Company, { onDelete: "CASCADE" }),
    __metadata("design:type", model_1.Company)
], APIAuthAccess.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIAuthAccess.prototype, "clientId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => APIClient, { onDelete: "CASCADE" }),
    __metadata("design:type", APIClient)
], APIAuthAccess.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Array)
], APIAuthAccess.prototype, "scopes", void 0);
exports.APIAuthAccess = APIAuthAccess = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], APIAuthAccess);
let APIAuthToken = class APIAuthToken {
    constructor(init = {}) {
        this.scopes = [];
        Object.assign(this, init);
    }
};
exports.APIAuthToken = APIAuthToken;
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], APIAuthToken.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], APIAuthToken.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], APIAuthToken.prototype, "token", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Array)
], APIAuthToken.prototype, "scopes", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], APIAuthToken.prototype, "clientId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => APIClient, { onDelete: "CASCADE", nullable: true }),
    __metadata("design:type", APIClient)
], APIAuthToken.prototype, "client", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], APIAuthToken.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Company, { onDelete: "CASCADE" }),
    __metadata("design:type", model_1.Company)
], APIAuthToken.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], APIAuthToken.prototype, "expires", void 0);
exports.APIAuthToken = APIAuthToken = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], APIAuthToken);
/**
 * @deprecated
 */
let MonthlyStatement = class MonthlyStatement {
    get from() {
        return (0, utils_1.toDateString)(new Date(this.year, this.month, 1));
    }
    get to() {
        return (0, utils_1.toDateString)(new Date(this.year, this.month + 1, 1));
    }
    constructor(vals = {}) {
        this.updated = new Date();
        this.version = (0, version_1.getVersion)();
        this.reset = null;
        this.issues = [];
        Object.assign(this, vals);
    }
};
exports.MonthlyStatement = MonthlyStatement;
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Employee, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", model_1.Employee)
], MonthlyStatement.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", Number)
], MonthlyStatement.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", Number)
], MonthlyStatement.prototype, "year", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", Number)
], MonthlyStatement.prototype, "month", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], MonthlyStatement.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], MonthlyStatement.prototype, "version", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", {
        nullable: true,
    }),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "reset", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "time", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "vacation", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "bonus", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "cost", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { select: true }),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "items", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Array)
], MonthlyStatement.prototype, "issues", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], MonthlyStatement.prototype, "previousAverages", void 0);
exports.MonthlyStatement = MonthlyStatement = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], MonthlyStatement);
let Session = class Session {
    constructor(vals = {}) {
        this.revoked = false;
        this.clientInfo = null;
        Object.assign(this, vals);
    }
};
exports.Session = Session;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], Session.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Account, (a) => a.sessions, { onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => model_1.Account),
    __metadata("design:type", model_1.Account)
], Session.prototype, "account", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], Session.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Company, { nullable: true, onDelete: "CASCADE" }),
    (0, class_transformer_1.Type)(() => model_1.Company),
    __metadata("design:type", Object)
], Session.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Session.prototype, "token", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    __metadata("design:type", Date)
], Session.prototype, "created", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], Session.prototype, "scope", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: Date, nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "expires", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: Date, nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "lastUsed", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: false }),
    __metadata("design:type", Boolean)
], Session.prototype, "revoked", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: "jsonb", nullable: true }),
    __metadata("design:type", Object)
], Session.prototype, "clientInfo", void 0);
exports.Session = Session = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], Session);
let TermsState = class TermsState {
    // new companies need to accept immediately to use Pentacode
    static defaultDeadline() {
        return new Date();
    }
    constructor(init = {}) {
        this.processingAgreementAccepted = null;
        this.termsAccepted = null;
        Object.assign(this, init);
    }
};
exports.TermsState = TermsState;
__decorate([
    (0, typeorm_1.PrimaryColumn)({ nullable: false }),
    __metadata("design:type", Number)
], TermsState.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => model_1.Company, { nullable: true, onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "companyId", referencedColumnName: "id" }),
    __metadata("design:type", model_1.Company)
], TermsState.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TermsState.prototype, "processingAgreementAccepted", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", { nullable: true, default: null }),
    __metadata("design:type", Object)
], TermsState.prototype, "termsAccepted", void 0);
__decorate([
    (0, typeorm_1.Column)("timestamptz", {
        nullable: false,
    }),
    __metadata("design:type", Date)
], TermsState.prototype, "deadline", void 0);
exports.TermsState = TermsState = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], TermsState);
let DailyResults = class DailyResults {
    constructor(init = {}) {
        this.timeBalancePlanned = null;
        this.issues = null;
        Object.assign(this, init);
    }
};
exports.DailyResults = DailyResults;
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Employee, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", model_1.Employee)
], DailyResults.prototype, "employee", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", Number)
], DailyResults.prototype, "employeeId", void 0);
__decorate([
    (0, typeorm_1.PrimaryColumn)("date"),
    __metadata("design:type", String)
], DailyResults.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "timeBalance", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], DailyResults.prototype, "timeBalancePlanned", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "vacationBalance", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "bonusesBalance", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "results", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb"),
    __metadata("design:type", Object)
], DailyResults.prototype, "averages", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DailyResults.prototype, "updated", void 0);
__decorate([
    (0, typeorm_1.Column)("jsonb", { nullable: true }),
    __metadata("design:type", Object)
], DailyResults.prototype, "issues", void 0);
exports.DailyResults = DailyResults = __decorate([
    (0, typeorm_1.Entity)(),
    (0, typeorm_1.Index)("IDX_employee_date_issues", ["employeeId", "date", "issues"], { unique: true }),
    __metadata("design:paramtypes", [Object])
], DailyResults);
let EmployeeTag = class EmployeeTag {
    constructor(init = {}) {
        this.order = 0;
        Object.assign(this, init);
    }
};
exports.EmployeeTag = EmployeeTag;
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], EmployeeTag.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], EmployeeTag.prototype, "color", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => model_1.Company, { onDelete: "CASCADE", eager: false }),
    __metadata("design:type", model_1.Company)
], EmployeeTag.prototype, "company", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, typeorm_1.Index)(),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "companyId", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)(() => model_1.Employee, (employee) => employee.tags, { eager: false }),
    __metadata("design:type", Array)
], EmployeeTag.prototype, "employees", void 0);
__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    __metadata("design:type", Number)
], EmployeeTag.prototype, "order", void 0);
exports.EmployeeTag = EmployeeTag = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], EmployeeTag);
//# sourceMappingURL=entities.js.map